import { j as e } from "../../../../_virtual/jsx-runtime.js";
import z from "../../../atoms/BaseCardHeader/index.js";
import c from "./AhiIndicator.js";
import { cn as i } from "../../../../lib/utils.js";
import B from "../../../atoms/SkeletonWrapper/index.js";
import { ChartContainer as D } from "../../../ui/chart.js";
import { COMMON_COLORS as H } from "../../../../constants/colors.js";
import P from "../../../atoms/charts/TooltipWrapper/index.js";
import T from "../../../atoms/charts/PayloadContent/index.js";
import { DIRECTION as y } from "./types.js";
import { ResponsiveContainer as E } from "../../../../node_modules/recharts/es6/component/ResponsiveContainer.js";
import { BarChart as G } from "../../../../node_modules/recharts/es6/chart/BarChart.js";
import { CartesianGrid as W } from "../../../../node_modules/recharts/es6/cartesian/CartesianGrid.js";
import { XAxis as F } from "../../../../node_modules/recharts/es6/cartesian/XAxis.js";
import { YAxis as b } from "../../../../node_modules/recharts/es6/cartesian/YAxis.js";
import { Bar as n } from "../../../../node_modules/recharts/es6/cartesian/Bar.js";
import { Tooltip as U } from "../../../../node_modules/recharts/es6/component/Tooltip.js";
const oe = ({
  title: C,
  isLoading: d,
  className: p,
  rightHeaderContent: k,
  data: m,
  config: r,
  leftAxisLabel: w = "Hours",
  rightAxisLabel: I = "AHI",
  ahiScoreThreshold: l = 15,
  tooltipFormatter: N
}) => {
  const S = ({ payload: t }, a) => {
    var x, h, j, u, A, f;
    if (!(t != null && t[0]))
      return null;
    const { date: s, highAhi: v, lowAhi: L, noRemSleep: R, noSleep: O } = t[0].payload;
    let o = r.noAhi;
    v && (o = r.highAhi), L && (o = r.lowAhi);
    const K = t.filter(
      (M) => !["lowAhi", "highAhi"].includes(M.dataKey)
    );
    return /* @__PURE__ */ e.jsxs(P, { className: "transform -translate-x-[56%]", children: [
      /* @__PURE__ */ e.jsx("span", { children: s }),
      R && /* @__PURE__ */ e.jsxs("div", { className: "flex flex-row gap-1", children: [
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: i("flex self-center rounded-full h-2.5 w-2.5 mr-1"),
            style: {
              backgroundColor: (x = r == null ? void 0 : r.noRemSleep) == null ? void 0 : x.color
            }
          }
        ),
        /* @__PURE__ */ e.jsxs("span", { children: [
          (h = r == null ? void 0 : r.noRemSleep) == null ? void 0 : h.label,
          ": ",
          (j = r == null ? void 0 : r.noRemSleep) == null ? void 0 : j.unit
        ] })
      ] }),
      O && /* @__PURE__ */ e.jsxs("div", { className: "flex flex-row gap-1", children: [
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: i("flex self-center rounded-full h-2.5 w-2.5 mr-1"),
            style: {
              backgroundColor: (u = r == null ? void 0 : r.noSleep) == null ? void 0 : u.color
            }
          }
        ),
        /* @__PURE__ */ e.jsxs("span", { children: [
          (A = r == null ? void 0 : r.noSleep) == null ? void 0 : A.label,
          ": ",
          (f = r == null ? void 0 : r.noSleep) == null ? void 0 : f.unit
        ] })
      ] }),
      /* @__PURE__ */ e.jsx(T, { payload: K, config: r, formatter: a }),
      /* @__PURE__ */ e.jsxs("div", { className: "flex flex-row gap-1", children: [
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: i("flex self-center rounded-full h-2.5 w-2.5 mr-1"),
            style: {
              backgroundColor: o.color
            }
          }
        ),
        /* @__PURE__ */ e.jsx("span", { children: o.label })
      ] })
    ] });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      z,
      {
        title: C,
        leftIconProps: { iconName: "TimeLine" },
        className: i("items-center mb-6", p),
        isLoading: d,
        rightContentClassName: "flex flex-1 space-around",
        size: "base",
        children: k
      }
    ),
    /* @__PURE__ */ e.jsx(B, { isLoading: d, children: /* @__PURE__ */ e.jsx(
      D,
      {
        style: { height: 250 },
        className: i("trends-chart w-full", p),
        config: r,
        children: /* @__PURE__ */ e.jsx(E, { width: "100%", height: "100%", children: /* @__PURE__ */ e.jsxs(
          G,
          {
            data: m,
            margin: { top: 32, right: -25, left: -25, bottom: 20 },
            barGap: 0,
            barCategoryGap: "15%",
            children: [
              /* @__PURE__ */ e.jsx(W, { stroke: H.greyLight }),
              /* @__PURE__ */ e.jsx(
                F,
                {
                  dataKey: "date",
                  tick: { fontSize: 10 },
                  tickMargin: 10,
                  tickLine: !1,
                  axisLine: !1
                }
              ),
              /* @__PURE__ */ e.jsx(
                b,
                {
                  yAxisId: "left",
                  tickLine: !1,
                  axisLine: !1,
                  label: {
                    value: w,
                    position: "insideTopLeft",
                    style: { textAnchor: "top" },
                    dy: -35,
                    dx: 25
                  },
                  ticks: [0, 6, 12],
                  domain: [0, l],
                  tickMargin: 10
                }
              ),
              /* @__PURE__ */ e.jsx(
                b,
                {
                  yAxisId: "right",
                  orientation: "right",
                  tickLine: !1,
                  axisLine: !1,
                  ticks: [l],
                  domain: [0, l],
                  tickMargin: 10,
                  dy: 10,
                  label: {
                    value: I,
                    position: "insideTopRight",
                    style: { textAnchor: "top" },
                    dy: -35,
                    dx: -25
                  }
                }
              ),
              /* @__PURE__ */ e.jsx(
                n,
                {
                  yAxisId: "left",
                  dataKey: "remSleep",
                  stackId: "a",
                  fill: r.remSleep.color,
                  name: r.remSleep.label,
                  animationDuration: 1e3,
                  barSize: 10
                }
              ),
              /* @__PURE__ */ e.jsx(
                n,
                {
                  yAxisId: "left",
                  dataKey: "sleep",
                  stackId: "a",
                  fill: r.sleep.color,
                  name: r.sleep.label,
                  animationDuration: 1e3,
                  barSize: 10,
                  radius: [20, 20, 0, 0]
                }
              ),
              /* @__PURE__ */ e.jsx(
                n,
                {
                  yAxisId: "left",
                  dataKey: "lowAhi",
                  stackId: "a",
                  fill: "transparent",
                  name: r.lowAhi.label,
                  label: ({ x: t, y: a, index: s }) => /* @__PURE__ */ e.jsx(
                    c,
                    {
                      x: t,
                      y: a,
                      ahiScoreThreshold: l,
                      direction: y.DOWN,
                      hidden: !m[s].lowAhi
                    }
                  )
                }
              ),
              /* @__PURE__ */ e.jsx(
                n,
                {
                  yAxisId: "left",
                  dataKey: "highAhi",
                  stackId: "a",
                  fill: "transparent",
                  name: r.highAhi.label,
                  label: ({ x: t, y: a, index: s }) => /* @__PURE__ */ e.jsx(
                    c,
                    {
                      x: t,
                      y: a,
                      ahiScoreThreshold: l,
                      direction: y.UP,
                      hidden: !m[s].highAhi
                    }
                  )
                }
              ),
              /* @__PURE__ */ e.jsx(
                U,
                {
                  content: (t) => S(t, N),
                  allowEscapeViewBox: { x: !0, y: !0 },
                  isAnimationActive: !1,
                  cursor: !1
                }
              )
            ]
          }
        ) })
      }
    ) })
  ] });
};
export {
  oe as default
};
